import { render, staticRenderFns } from "./WfConsumerCorpRechargeForm.vue?vue&type=template&id=b5a17964&"
import script from "./WfConsumerCorpRechargeForm.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpRechargeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports